import React from 'react';
import './Spinner.css';

interface SpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: 'green' | 'blue' | 'white';
    className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ 
    size = 'medium', 
    color = 'green', 
    className = '' 
}) => {
    return (
        <div className={`spinner-container ${className}`}>
            <div className={`spinner spinner-${size} spinner-${color}`}></div>
        </div>
    );
};

export default Spinner;
